import { ArrowRight } from "lucide-react";

const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const navHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - navHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="min-h-screen bg-cream pt-20 relative overflow-hidden"
    >
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[calc(100vh-80px)] py-12 lg:py-0">
          {/* Content */}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            {/* Overline */}
            <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-6">
              Airbnb Management · Listing Optimisation · Local Experiences
            </p>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-serif text-bark leading-[1.1] mb-6">
              Your Airbnb business,
              <br />
              <span className="italic">expertly managed.</span>
            </h1>

            {/* Subheading */}
            <p className="text-lg text-bark-light max-w-lg mb-10 leading-relaxed">
              Co-hosting, listing optimisation, and curated local experiences
              across Bribie Island and Southeast Queensland.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, "#contact")}
                data-testid="hero-cta-button"
                className="btn-primary flex items-center justify-center gap-2 group"
              >
                Start With a Free Audit
                <ArrowRight
                  size={18}
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <a
                href="#how-it-works"
                onClick={(e) => scrollToSection(e, "#how-it-works")}
                data-testid="hero-secondary-cta"
                className="btn-secondary text-center"
              >
                See How It Works
              </a>
            </div>

            {/* Trust Signals */}
            <div className="flex flex-wrap items-center text-sm text-bark-light">
              <span className="flex items-center">
                <span className="text-gold font-semibold mr-1">2</span>
                Properties Managed
              </span>
              <span className="trust-divider hidden sm:block" />
              <span className="w-full sm:w-auto mt-2 sm:mt-0 flex items-center">
                <span className="text-gold font-semibold mr-1">100%</span>
                5-Star Reviews
              </span>
              <span className="trust-divider hidden sm:block" />
              <span className="w-full sm:w-auto mt-2 sm:mt-0">
                Local Experts
              </span>
            </div>
          </div>

          {/* Hero Image */}
          <div className="order-1 lg:order-2 animate-fade-in animate-delay-200">
            <div className="relative">
              {/* Main Image */}
              <div className="relative aspect-[4/5] lg:aspect-[3/4] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80"
                  alt="Beautiful coastal property interior"
                  className="w-full h-full object-cover"
                  data-testid="hero-image"
                />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-bark/20 to-transparent" />
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-4 -left-4 w-32 h-32 border border-gold/30 -z-10" />
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gold-light -z-10" />
            </div>
          </div>
        </div>
      </div>

      {/* Background decorative element */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-bark/10" />
    </section>
  );
};

export default Hero;
